const RefundModal = ({
  isOpen,
  message,
  amount,
  onAmountChange,
  onConfirm,
  onCancel,
}) => {
  if (!isOpen) return null;

  return (
    <div className="confirm-modal-overlay">
      <div className="modal-content">
        <p>{message}</p>
        <input
          type="number"
          step="0.01"
          min="0.01"
          value={amount}
          onChange={(e) => onAmountChange(e.target.value)}
          className="refund-modal-input"
        />
        <div className="modal-actions">
          <button className="btn-danger" onClick={onConfirm}>
            Confirm
          </button>
          <button className="btn-secondary" onClick={onCancel}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default RefundModal;
